import { useEffect } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './SideMenu.module.css';
import { useAdminAuth } from '../AdminAuthContext';

const AdminMain = () => {
  const { isAdminLoggedIn, isCheckingAuth } = useAdminAuth(); 
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("[AdminMain] isCheckingAuth:", isCheckingAuth);
    console.log("[AdminMain] isAdminLoggedIn:", isAdminLoggedIn);
    if (!isCheckingAuth && !isAdminLoggedIn) {
      navigate('/admin/login');
    }
  }, [isCheckingAuth, isAdminLoggedIn, navigate]);

  const handleLogout = async () => {
    try {
        localStorage.removeItem("adminAccessToken");
        delete axios.defaults.headers.common['Authorization'];
        navigate('/admin/login');
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <h2>Admin</h2>
        <nav>
          <Link to="/admin/dashboard" className={location.pathname === '/admin/dashboard' ? styles.active : ''}>
            Dashboard
          </Link>
          <Link to="/admin/settings" className={location.pathname === '/admin/settings' ? styles.active : ''}>
            Settings
          </Link>
          <Link to="/admin/article-upload" className={location.pathname === '/admin/article-upload' ? styles.active : ''}>
            Upload Article
          </Link>
          <Link to="/admin/article-manage" className={location.pathname === '/admin/article-manage' ? styles.active : ''}>
            Manage Articles
          </Link>
        </nav>
        <button className={styles.logoutButton} onClick={handleLogout}>Logout</button>
      </aside>
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminMain;
